// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"112":"build-glob","220":"build-doc","839":"build-map"}[chunkId] + "-legacy." + {"112":"d73633fb","220":"7afd1246","839":"20665538"}[chunkId] + ".js";
};